export default "__VITE_ASSET__b469e1f9__"